<template>
  <div>
    <span v-translate>{{ label }}</span>
    <div v-for="(file, index) in files" :key="index">
      <a :href="file.url" target="_blank" download>{{ file.name }}</a>
    </div>
  </div>
</template>
<script>
  import File from '@/classes/case/File'

  export default {
    name: 'files-component',
    props: {
      label: {
        type: String,
        required: false
      },
      files: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof File),
        required: true
      }
    }
  }
</script>
